import utils from '@/mixins/utils'

/**
 * Filtra a lista de cadastros conforme os filtros selecionados.
 *
 * @param {Array<Object>} cadastros Lista de cadastros a serem filtrados.
 * @param {Boolean} exibirVermelhos Indica se devem ser exibidos apenas os cadastros vermelhos.
 * @param {Boolean} exibirVerdes Indica se devem ser exibidos apenas os cadastros verdes.
 * @param {Object} selectedEquipe Equipe selecionada.
 * @param {Object|null} mes Mês selecionado no filtro.
 *
 * @returns {Array<Object>} Lista de cadastros filtrados.
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedEquipe = null,
  mes = null
) {
  let cadastros_filtrados = cadastros || []

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const exodontias = item.num_taxa_exod != 0

      if (!mes) {
        return exodontias
      }

      const mesSelecionado = Number(mes?.value || mes)

      let dados = []

      try {
        dados =
          typeof item.dados === 'string'
            ? JSON.parse(item.dados)
            : item.dados || []
      } catch (e) {
        dados = []
      }

      const registroMes = dados.find((dado) => {
        return (
          Number(dado.nm) != 0 &&
          Number(dado.nu_mes) === mesSelecionado &&
          selectedEquipe.ine_esb == dado.nu_ine
        )
      })

      return exodontias && !!registroMes
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      return item.num_taxa_exod == 0
    })
  }

  return cadastros_filtrados
}
